"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.NetworkProvider = exports.request = void 0;
var React = require("react");
var recoil_1 = require("recoil");
var onOnline_1 = require("../utils/onOnline");
var errorNumbers = new Set();
/**
 * 任意のタイミングでリトライさせるための Atom
 * URL ごとに作成される
 */
var retrys = recoil_1.atomFamily({
    key: 'retrys',
    default: function () { return 0; }
});
var _count = 0;
/**
 * オフラインで失敗したあと、オンラインに復帰したときに
 * 自動的にリトライしてくれる selector
 * 一度でも取得に成功している場合は同期的に値を返す
 */
exports.request = recoil_1.selectorFamily({
    key: 'request',
    get: function (src) { return function (_a) {
        var get = _a.get;
        var number = ++_count; // 一意な ID を割り振る
        get(retrys(number)); // エラーになった場合 online になったら再評価する
        return fetch(src).catch(function (error) {
            errorNumbers.add(number);
            throw error;
        });
    }; }
});
function NetworkProvider() {
    var retryAllFailedRequests = recoil_1.useRecoilCallback(function (_a) {
        var set = _a.set;
        var copy = new Set(errorNumbers);
        errorNumbers.clear();
        copy.forEach(function (number) {
            set(retrys(number), function (curr) { return curr + 1; });
        });
    }, []);
    React.useEffect(function () {
        return onOnline_1.onOnline(function () {
            retryAllFailedRequests();
        });
    }, [retryAllFailedRequests]);
    return null;
}
exports.NetworkProvider = NetworkProvider;
//# sourceMappingURL=NetworkProvider.js.map